import React, { Component } from 'react';
import JobFullDetailsInternalJobNote from './job-full-details-internal-job-note';

export default class JobFullDetailsInternalJobNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      notes:[],
      isLoading: true,
      noteData : [],
      updateNotes : false,
      showAddBox: false,
    };
    this.handleNoteChange = this.handleNoteChange.bind(this);
    this.handleDeleteNote = this.handleDeleteNote.bind(this);
    this.renderNotes = this.renderNotes.bind(this);
    this.renderAddNewNoteButton = this.renderAddNewNoteButton.bind(this);
    this.renderAddNewNoteForm = this.renderAddNewNoteForm.bind(this);
    this.handleAddNewNote = this.handleAddNewNote.bind(this);
  }

  componentDidMount(){
    this.getAllNotes();
  }

  getAllNotes() {
    let url = '/api/v1/portal/jobs/get-all-internal-jobnotes/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((jsondata) => {
        this.setState({
          notes: jsondata.notes,
          isLoading: false,
          updateNotes : true,
        })
      });
    });
  }

  handleNoteChange(e,noteid){
    let msgBody = $('#note-row-'+noteid).val();
    this.setState({isLoading:true});
    let that = this;
      $.ajax({
        url: '/api/v1/portal/jobs/set-internal-job-note/'+noteid,
        method: 'POST',
        data: {api_token: window.api_token,message_body: msgBody},
        cache: false
      })
      .done(function(response) {
        that.setState({isLoading:false, updateNotes : true});
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Note updated successfully!!');
        $('#infomodal').modal();
      }).catch(function(err){
        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html(err);
        $('#infomodal').modal();
      });
  }

  handleAddNewNote() {
    let msgBody = $('#add-new-internal-note').val();
    let that = this;
    this.setState({isLoading: true}); 
    $.ajax({
      url: '/api/v1/portal/jobs/add-new-internal-job-note/' + this.state.data.id,
      method: 'POST',
      data: { api_token: window.api_token, message_body: msgBody },
      cache: false
    }).done(function (response) {
      this.setState({
        isLoading: false,
        notes: response.note,
        updateNotes : true,
        showAddBox: false,
      });
      $('#infomodallabel').html('Success');
      $('#infomodal .modal-body').html('New note added successfully!!');
      $('#infomodal').modal();
    }.bind(this)).catch(function (err) {
      $('#infomodallabel').html('Error');
      $('#infomodal .modal-body').html(err);
      $('#infomodal').modal();
    });
  }
  
  handleDeleteNote = (noteId, note) => {
    let that=this;
    const confirmed = window.confirm("Are you sure you want to delete this note?");
    if (confirmed) {
      $.ajax({
        url: '/api/v1/portal/jobs/delete-internal-job-note',
        method: 'POST',
        data: {api_token: window.api_token, note_id: noteId, job_id: this.state.data.id, note : note},
        cache: false
      })
      .done(function(response) {
        $('#selector-note-'+noteId).remove();
        this.setState({updateNotes : true});
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html(response.message);
        $('#infomodal').modal();
      }).fail(function(xhr, status, error) { 
        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html(xhr.responseJSON.error);
        $('#infomodal').modal();
      });
    } 
  };

  renderNotes(){
    let internalNotes = [];
    if (this.state.notes && this.state.notes.length > 0) {
      this.state.notes.map((note) => {
        if (note.modifications && JSON.parse(note.modifications).note) {
          internalNotes.push(
            <JobFullDetailsInternalJobNote
              key={note.id}
              note={note}
              id={note.id}
              childJobId={note.child_job_id}
              parentJobId={note.parent_job_id}
              jobType={note.job_type}
              fullName={note.full_name}
              createdAt={note.created_at}
              handleDeleteNote={this.handleDeleteNote}
            />
          );
        }
      });
    }
    return internalNotes;
  }

  renderAddNewNoteButton(){
    return(
      <div className="row">
        <div className="col-md-12">
          <button className="btn btn-primary btn-lg" onClick={() => this.setState({ showAddBox: true })}><i className="fa fa-plus"></i> Add New Note ?</button>
        </div>
      </div>
    );
  }

  renderAddNewNoteForm(){
    return(
      this.state.showAddBox ? 
        <div className="row">
          <div className="col-md-10">
            <textarea className="form-control form-control-lg"
             id={"add-new-internal-note"}
             defaultValue=""
             >
            </textarea>
          </div>
          <div className="col-md-2 padding-top-btm">
            <button className="btn btn-primary btn-lg white-btn"
              onClick={this.handleAddNewNote}>Add Note
            </button>
          </div>
        </div>
        : null 
    );
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="subsection-container">
              {this.renderAddNewNoteButton()}
              <br />
              {this.renderAddNewNoteForm()}
              <br />
              {this.state.updateNotes ? this.renderNotes() : null}
              {(this.state.isLoading) ?
                <div className="text-center my-5">
                    <i className="fa fa-spinner fa-pulse fa-2x"></i>
                </div>
                : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}